import ".././App.css";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";

const Carousel = ({ onChangeSex, isMale }) => {
  const [selectedSex, setSelectedSex] = useState(null);

  const handleOnChangeSex = (sex) => {
    setSelectedSex(sex);
    onChangeSex(sex);
  };

  useEffect(() => {
    setSelectedSex(isMale);
  }, [isMale]);

  return (
    <Box id="CharacterCreator" className="componentBlocks">
      <img
        src={`https://storage.googleapis.com/anekdamian-site/preview/base/male/bm01c01.png`}
        onClick={() => {
          handleOnChangeSex("male");
        }}
        className="character-component"
        style={{ border: selectedSex === "male" ? "2px solid #91ab87" : "none", cursor: 'pointer', transition: '0.1s ease-in-out' }}
        alt="icon"
      />
      <img
        src={`https://storage.googleapis.com/anekdamian-site/preview/base/female/bf01c01.png`}
        onClick={() => {
          handleOnChangeSex("female");
        }}
        className="character-component"
        style={{ border: selectedSex === "female" ? "2px solid #91ab87" : "none", cursor: 'pointer', transition: '0.1s ease-in-out' }}
        alt="icon"
      />
    </Box>
  );
};

export default Carousel;
